import { BitkitDefinitionTooltip } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';

import {
  CacheStatusSource,
  getInvocationCacheStatus,
  InvocationCacheStatus,
} from '@/pages/BuildCache/BuildCachePageWrapper/pages/Invocations/utils/invocationCacheStatus';

type DotStyle = { background: string; borderWidth?: string; borderColor?: string };

const RING_DOT: DotStyle = {
  background: 'transparent',
  borderWidth: '1px',
  borderColor: 'color/neutral/muted',
};

const DOT_STYLES: Record<InvocationCacheStatus, DotStyle> = {
  [InvocationCacheStatus.inProgress]: { background: 'color/purple/bold' },
  [InvocationCacheStatus.baseline]: RING_DOT,
  [InvocationCacheStatus.warmingUp]: { background: 'color/neutral/moderate' },
  [InvocationCacheStatus.healthy]: { background: 'color/green/bold' },
  [InvocationCacheStatus.lowReuse]: { background: 'color/yellow/muted' },
  [InvocationCacheStatus.noActivity]: RING_DOT,
};

type CacheStatusCellProps = {
  invocation: CacheStatusSource;
};

const CacheStatusCell = ({ invocation }: CacheStatusCellProps) => {
  const { status, label, tooltip } = getInvocationCacheStatus(invocation);
  const dotStyle = DOT_STYLES[status];

  // The trigger is lifted above the row's stretched LinkOverlay — otherwise a click meant for the tooltip falls
  // through to the row link and navigates. Same technique as the project badge tooltip in this row.
  return (
    <Box display="flex" alignItems="center" gap="8">
      <Box width="8" height="8" borderRadius="8" flexShrink="0" {...dotStyle} />
      <Box as="span" position="relative" zIndex="1" display="inline-flex" maxWidth="100%">
        <BitkitDefinitionTooltip method="hover" placement="bottom" text={tooltip} textSize="md">
          {label}
        </BitkitDefinitionTooltip>
      </Box>
    </Box>
  );
};

export default CacheStatusCell;
